__turbopack_context__.v({
  "body": "CopyToAnotherAccountModal-module__gRtamW__body",
  "createButton": "CopyToAnotherAccountModal-module__gRtamW__createButton",
  "footer": "CopyToAnotherAccountModal-module__gRtamW__footer",
  "footerActions": "CopyToAnotherAccountModal-module__gRtamW__footerActions",
  "headerWithBack": "CopyToAnotherAccountModal-module__gRtamW__headerWithBack",
});
